<div class="modal fade" id="routerModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true" style="z-index: 1000000">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title fw-bold">{{title}}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
                </button>
            </div>
            <div class="modal-body">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item pe-1">
                            <a class="nav-link" jhiTranslate="inventory-details.nav.lot"
                               [routerLink]="[{ outlets: { modalContent: ['lot'] } }]" [routerLinkActive]="['active']" queryParamsHandling="merge"></a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" jhiTranslate="inventory-details.nav.transaction"
                               [routerLink]="[{ outlets: { modalContent: ['transaction'] } }]" [routerLinkActive]="['active']" [queryParams]="{lotId: null}" queryParamsHandling="merge"></a>
                        </li>
                    </ul>
                </nav>
                <div class="tab-content p-3">
                    <router-outlet name="modalContent"></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>




